import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService } from '@examdojo/supabase';
import { from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChallengeActivityHttpService extends SupabaseBaseHttpService<'challenge_activities', 'learning'> {
  readonly schema = 'learning';
  readonly tableName = 'challenge_activities';

  startChallenge(assignmentSectionId: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .rpc('challenge_start', { p_assignment_section_id: assignmentSectionId })
        .throwOnError()
        .then((res) => res.data),
    );
  }
}
